import { Link } from 'react-router-dom';

const footerLinks = {
  探索: [
    { label: '爱情与亲密', href: '/category/ai-qing-yu-qin-mi' },
    { label: '自我实现', href: '/category/zi-wo-shi-xian' },
    { label: '深层欲望', href: '/category/shen-ceng-yu-wang' },
    { label: '关系动力', href: '/category/guan-xi-dong-li' },
  ],
  关于: [
    { label: '关于我们', href: '/about' },
    { label: '品牌故事', href: '/about' },
    { label: '联系方式', href: '/about' },
  ],
  资源: [
    { label: '精选文章', href: '/category/shen-ceng-yu-wang' },
    { label: '常见问题', href: '/#faq' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/50">
      <div className="container-custom py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="text-xl font-bold font-heading text-primary-400">
              欲望之岛
            </Link>
            <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
              探索内心深处的欲望世界，发现最真实的自我。
            </p>
            <div className="flex items-center gap-4 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer" aria-label="小红书">
                <i className="ri-bookmark-line text-lg"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-foreground-200 mb-4 font-label">
                {title}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-300"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; {new Date().getFullYear()} 欲望之岛. 保留所有权利.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-600 hover:text-primary-400 transition-colors">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-600 hover:text-primary-400 transition-colors">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}